export enum PlanSummaryModals {
    APTCSuccess = 'APTCSuccess',
    APTCFailure = 'APTCFailure',
}
